// DOM micro-helpers shared by all UI modules.

import { clamp } from "../lib/text";

export const $ = <T extends HTMLElement = HTMLElement>(s: string): T => document.querySelector(s) as T;

export const el = (tag: string, cls?: string | null, txt?: string | null): HTMLElement => {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (txt != null) e.textContent = txt;
  return e;
};

/** The "navigator is thinking" placeholder: a pulse tag + shimmer skeleton. */
export function renderThinking(container: HTMLElement, label: string, rows: number): HTMLElement {
  container.innerHTML = "";
  const tag = el("div", "thinking-tag");
  tag.appendChild(el("span", "dot"));
  tag.appendChild(document.createTextNode(label));
  container.appendChild(tag);
  const sk = el("div", "skeleton");
  for (let i = 0; i < rows; i++) sk.appendChild(el("div", "sk-opt"));
  container.appendChild(sk);
  return sk;
}

export function setBar(barEl: HTMLElement, frac: number): void {
  let i = barEl.querySelector("i");
  if (!i) { i = document.createElement("i"); barEl.appendChild(i); }
  const f = clamp(frac, 0, 1);
  i.className = f < 0.34 ? "lo" : f < 0.7 ? "mid" : "hi";
  i.style.width = (f * 100).toFixed(0) + "%";
}

export function bar(frac: number): HTMLElement {
  const b = el("span", "bar");
  setBar(b, frac);
  return b;
}
